import debounce from "../util/debounce";
import ScrollController from '../js/ScrollController'
export default class ScrollImpController {
    constructor({
                    STAY_TIME = 2000,
                    EXPOSED_PERCENT = 0.5,
                    isHalfAppPage = false,
                    scrollImpArray = [],
                    exposureScrollArray = [],
                    sensorsTrack = () => {}
                }) {
        this.dataSchedule = this.dataSchedule.bind(this);
        this.triggerScrollImp = this.triggerScrollImp.bind(this);
        this.scrollController = new ScrollController({
            STAY_TIME,
            EXPOSED_PERCENT,
            isHalfAppPage,
            scrollImpArray,
            dataSchedule: this.dataSchedule,
            track: sensorsTrack
        });
        this.scrollImpArray = scrollImpArray; // 滚动曝光数组
        this.exposureScrollArray = exposureScrollArray; // 已滚动曝光数据
    }

    triggerScrollImp() {
        this.scrollController.triggerScrollImp();
    }

    dataSchedule(item, index, classList, status) {
        if (status === 'end') {
            return this.mergeImp(this.tgt_nameMap);
        }
        if (status === 'start') {
            this.tgt_nameMap = new Map([['default', []]]);
            return this.tgt_nameMap;
        }
        if (item) {
            this.exposureScrollArray.push(item);
            // 更新当前tgt_nameMap，便于后续合并埋点
            this.scrollImpArray.splice(index, 1);
            return this.updateTgtNameMap(item, classList, this.tgt_nameMap);
        }
        return this.tgt_nameMap;
    }

    // tgt_nameMap 数据结构
    // {
    //     'default': [],
    //     '{\"tgt_name\":\"super-资源位-banner轮播\",\"colItemNum\":99}':
    //         [
    //             {
    //                 "tgt_event_id": "super_resState",
    //                 "tgt_name": "super-资源位-banner轮播",
    //                 "page": "super-首页",
    //                 "position": 1,
    //                 "param": "隐私协议公告",
    //                 "param1": 4,
    //                 "param2": 1,
    //                 "param3": 1,
    //                 "param4": "0",
    //                 "param5": "https://loanweb.ppdai.com/web/help/privacyPolicy.html",
    //                 "param6": "https://file1.m.ppdai.com/54906234155a498aa1c344d14be7131d.png",
    //                 "param7": "null",
    //                 "param8": "null",
    //                 "param9": "腰封banner",
    //                 "param10": "0"
    //             }
    //         ]
    // }
    updateTgtNameMap(item, classList, tgt_nameMap) {
        // 找这个节点的class是否在rowAmountMap里，如果在，就放进classObj[className],如果不在，就放进default里，后续将不会对其进行合并埋点的操作
        if (
            typeof item.config.needCombine !== 'undefined' &&
            !item.config.needCombine
        ) {
            // 代表不需要合并，直接放进default里即可
            tgt_nameMap.set('default', [...tgt_nameMap.get('default'), item]);
            return tgt_nameMap;
        }
        let isFind = false;
        for (let i = 0; i < classList.length; i++) {
        // for (let className of classList) {
            let className = classList[i]
            let colItemNum = item.config && item.config.rowAmountMap && item.config.rowAmountMap[className];
            let tgt_nameMapKey = JSON.stringify({
                tgt_name: item.tgt_name,
                colItemNum
            });
            if (colItemNum > 0) {
                typeof tgt_nameMap.get(tgt_nameMapKey) === 'undefined' &&
                tgt_nameMap.set(tgt_nameMapKey, []);
                tgt_nameMap.set(tgt_nameMapKey, [
                    ...tgt_nameMap.get(tgt_nameMapKey),
                    item
                ]);
                isFind = true;
                break;
            }
        }
        if (!isFind) {
            tgt_nameMap.set('default', [...tgt_nameMap.get('default'), item]);
        }
        return tgt_nameMap;
    }

    mergeImp(tgt_nameMap) {
        // 合并埋点，一行一个点
        // 判断这点在第几列=position%num，在第几行=position/num ceil
        // 合并的规则详见首页及账户页埋点文档
        let defaultArray = [];
        let combineImpArray = [];
        let makeGoodData = data => {
            return data ? data : '-';
        };
        for (let [tgt_nameObjStr, impObjArray] of tgt_nameMap) {
            let tgt_nameObj = null;
            if (tgt_nameObjStr === 'default') {
                defaultArray = [
                    ...defaultArray,
                    ...tgt_nameMap.get(tgt_nameObjStr)
                ];
                continue;
            } else {
                tgt_nameObj = JSON.parse(tgt_nameObjStr);
            }
            // 初始模板
            let modelObj = {};
            let valObj = JSON.parse(JSON.stringify(impObjArray[0]));
            let config = valObj.config || {};
            // 几列
            let colAmount =
                tgt_nameObj.colItemNum >= 99
                    ? impObjArray.length
                    : tgt_nameObj.colItemNum; // 一行有几列。若该class一行可放99个，代表这是个叠起来的位置，类似于banner，一行的数量==该类型的array的长度
            // 有几行
            let rowAmount = Math.ceil(impObjArray.length / colAmount);
            modelObj = {
                tgt_event_id: valObj.tgt_event_id,
                // tgt_name: valObj.tgt_name,
                page: valObj.page || ''
            };
            // console.log('this.positionParamName', this);
            // 模块里有几行几列
            config.positionParamName &&
            (modelObj[
                config.positionParamName
                ] = `${rowAmount}_${colAmount}`);
            // 有没有不需要合并起来的param,如果有就给这些属性赋值，因为一行的元素被确认是同一种元素，所以用第一个元素的这些值作为默认值就行
            config.noCombineParams &&
            config.noCombineParams.map(item => {
                modelObj[item] = valObj[item] || null;
                return item;
            });
            let newImpArray = [];
            newImpArray.length = rowAmount;
            // 初始化
            for (let i = 0; i < newImpArray.length; i++) {
                newImpArray[i] = JSON.parse(JSON.stringify(modelObj));
            }
            for (let t in impObjArray) {
                if (impObjArray[t]) {
                    let item = impObjArray[t];
                    // 元素的序号
                    let index = item.position;
                    // 在第几行
                    let colNum = Math.ceil(
                        Number(index) / tgt_nameObj.colItemNum
                    );
                    if (colNum > newImpArray.length) {
                        colNum = newImpArray.length;
                    }
                    let separator =
                        Number(t) % tgt_nameObj.colItemNum == 0 ? '' : '|';
                    // console.log(newImpArray[colNum - 1]);
                    newImpArray[colNum - 1].position = colNum;
                    for (let key in item) {
                        if (
                            typeof modelObj[key] !== 'undefined' ||
                            key === 'config'
                        ) {
                            // 这些值在文档里不需要合并或者已经赋值过了
                            continue;
                        }
                        if (key === 'tgt_name' && t !== '0') {
                            // 如果为tgt_name，则拼接比较特殊，例如super-贷超资源位-${资源位标题}|${资源位标题}|${资源位标题}
                            let tgt_name = item[key].split('-');
                            newImpArray[colNum - 1][key] =
                                newImpArray[colNum - 1][key] +
                                separator +
                                makeGoodData(tgt_name[tgt_name.length - 1]);
                        } else {
                            if (
                                typeof newImpArray[colNum - 1][key] ===
                                'undefined'
                            ) {
                                newImpArray[colNum - 1][key] = '';
                            }
                            newImpArray[colNum - 1][key] =
                                newImpArray[colNum - 1][key] +
                                separator +
                                makeGoodData(item[key]);
                        }
                    }
                    delete item.config // 删除config，避免录入去重判断失败
                }
            }
            combineImpArray = [...combineImpArray, ...newImpArray];
        }
        // console.log([...defaultArray, ...combineImpArray]);
        return [...defaultArray, ...combineImpArray];
    }

}
